import styled from "styled-components";
import { Link } from "gatsby";
import { palette } from "../../styles/global";
import { up, down, between, only } from 'styled-breakpoints';
import { ButtonArrow } from "../shapes";


type MenuItemWrapperProps = {
  border?: string
  active?: boolean
  scroll: number,
  outlined?: boolean,
}

export const MenuItemWrapper = styled.div<MenuItemWrapperProps>`
  position: relative;
  transition: all 0.5s;
  padding: ${props => props.scroll < 100 ? '50px 1.5vw 45px 1.5vw' : '30px 1.5vw 25px 1vw'};
  ${down('xxl')}{
    padding: ${props => props.scroll < 100 ? '50px 1vw 45px 1vw' : '30px 1vw 25px 1vw'};
  }
  ${down('xl')}{
    padding: ${props => props.scroll < 100 ? '50px 0.5vw 45px 0.5vw' : '30px 0.5vw 25px 0.5vw'};
  }
  text-align: center;
  font-weight: 900;
  font-size: 1.1rem;
  ${between('lg', 'xl')}{
    font-size: 1rem;
  }
  letter-spacing: 0px;
  border-top: ${props => props.border ? `7px solid ${props.border}` : props.outlined && props.active ? "7px solid #2A3349" : "7px solid white"};
  background-color: ${props => props.active ? props.outlined ? '#2A3349' : props.border : '#ffffff'};
  color: ${props => props.active ? palette.white : palette.text.primary};
  :hover{
    background-color: ${props => props.border && !props.active ? props.border : '#2A3349'};
    color: ${props => props.border ? '#ffffff' : 'unset'}
  }
`

type MenuItemProps = {
  outlined?: boolean,
  active?: boolean,
  scroll: number,
  background: string,
}

export const MenuItemLocal = styled.span <MenuItemProps>`
  padding: ${props => props.outlined ? '10px 30px 7px 30px' : '10px 0 10px 0'} ;
  color: ${props => props.outlined ? palette.text.white : 'inherit'};
  text-transform: uppercase;
  text-decoration: none;
  background-color: ${props => props.outlined ? props.active ? '#2A3349' : palette.red : 'inherit'};
`

export const MenuItemBlank = styled.span<MenuItemProps>`
  padding: ${props => props.outlined ? '10px 30px 7px 30px' : '10px 0 10px 0'} ;
  color: ${props => props.outlined ? palette.text.white : 'inherit'};
  text-transform: uppercase;
  text-decoration: none;
  background-color: ${props => props.outlined ? props.active ? '#2A3349' : props.background : 'inherit'};

  :hover{
    filter: brightness(${props => props.outlined && !props.active ? '85%' : '100%'});
  }
`

type ItemWrapperProps = {
  color?: string
}

export const MobileMenuItemWrapper = styled.div<ItemWrapperProps>`
  background-color: ${props => props.color ? props.color : 'inherit'};
  padding: 3vh 0 3vh 0;
  text-align: center;
  font-weight: 300;
  font-size: 2rem;
  letter-spacing: 0px;
  z-index: 10;
  font-size: 200;
  color: ${props => props.color && (props.color == '#ffffff' || props.color == '#20BBFC') ? '#000000' : 'inherit'};
  line-height: 1.5;
`

type ChildrenWrapperProps = {
  open: boolean,
  color: string,
  scroll: number,
}

export const ChildrenWrapper = styled.div<ChildrenWrapperProps>`

  display: ${props => props.open ? 'flex' : 'none'};
  opacity: ${props => props.open ? 1 : 0};
  background-color: ${props => props.color};
  ${up('lg')}{
    position: absolute;
    top: 100%;
    margin: auto;
    left:0;
    z-index: 10;
  }
  ${down('lg')}{
    margin-top:1rem;
    width: 100%;
    flex-direction: column;
    align-items: center;
    font-size: 2rem;
  }
 
  color: ${palette.white};
  transition: all 0.5s;
  flex-direction: column;
  text-align: center; // optional, but helps horizontally center text that breaks into multiple lines
  
`

export type ColorProps = {
  color: string,
}

export const ChildrenItemWrapper = styled.div<ColorProps>`
  background-color: ${props => props.color};
  display: flex;
  align-items: center;
  letter-spacing: 0px;
  text-align: center;
  font-weight: 900;
  font-size: 1.1rem;
  padding: 10px 1.5vw 10px 1.5vw;
  transition: all 0.5s;
  color: inherit;
  ${down('lg')}{
    font-size: 2rem;
  }
  :hover{
    filter: brightness(85%);
  }
  white-space: nowrap;
`

type OpenProps = {
  open: boolean
}


export const MoreIconWrapper = styled.span<OpenProps>`
  display: inline-block;
  align-items: center;
  justify-content: center;
  transform: ${props => props.open ? 'scaleY(-1)' : 'scaleY(1)'};
  transition:all 0.3s;
  margin-left: 1rem;
  padding-bottom: 0.5rem;
`
export const MoreIcon = styled.figure<OpenProps>`
  margin: 0;
  width: 1rem;
  height: 1rem;
  border-top: 2px solid ${palette.white};
  border-left: 2px solid ${palette.white};
  text-decoration: none;
  transform: rotate(-135deg);
  display: block;
  
`

export const ClearLink = styled(Link)`
  color: inherit;
  text-decoration: none;
`